export const RETRY_FETCH = 'giftSets/RETRY_FETCH';

export const DELETE_GIFT_SET = 'giftSets/DELETE';

export const TOGGLE_VISIBILITY = 'giftSets/TOGGLE_VISIBILITY';
